import clsx from 'clsx';
import type { LucideIcon } from 'lucide-react';
import type { ComponentProps } from 'react';

import StatusBadge from '@/shared/ui/fleet-system/StatusBadge';
import { FILTER_UI_ICONS } from './filterIcons';
import { filterTriggerClass } from './styles';

type FilterDropdownTriggerProps = ComponentProps<'button'> & {
  label: string;
  icon?: LucideIcon;
  count: number;
  active: boolean;
};

/** Il pulsante di un filtro a tendina, da usare come trigger Radix (`asChild`). */
export default function FilterDropdownTrigger({
  label,
  icon: Icon,
  count,
  active,
  className,
  ...props
}: FilterDropdownTriggerProps) {
  return (
    <button
      type="button"
      className={clsx('group', filterTriggerClass({ active }), className)}
      {...props}
    >
      {Icon ? <Icon className="h-3.5 w-3.5" aria-hidden /> : null}
      {/* Lo spazio tiene separati etichetta e conteggio nel nome accessibile ("Gruppo 2"). */}
      <span>{label}</span> {count > 0 ? <StatusBadge count>{count}</StatusBadge> : null}
      <FILTER_UI_ICONS.chevronDown
        aria-hidden
        className="h-3.5 w-3.5 transition-transform duration-200 group-data-[state=open]:rotate-180"
      />
    </button>
  );
}
